import { Box, xcss } from '@atlaskit/primitives';
import React from 'react';
const wrapperStyles = xcss({
  display: 'flex',
  flexDirection: 'column'
});
export const CustomMenuList = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: wrapperStyles
  }, children);
};